// node modules
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import AddToCollectionWrapper from 'components/AddToCollectionWrapper';

import useStyles from 'isomorphic-style-loader/useStyles';

// app modules: components
import Icon from 'components/Icon';

import { COLOURS } from 'constants/index';

import AddToCollectionButtonStyles from './AddToCollectionButton.scss';

function AddToCollectionButton({ itemId, itemType }) {
  useStyles(AddToCollectionButtonStyles);
  const [isOpen, setIsOpen] = useState(false);
  const icon = <Icon fill={COLOURS.ENERGIZED} name="list-add" height="20" width="20" />;

  const handleOpenClick = () => {
    setIsOpen(true);
  };

  return (
    <Fragment>
      {isOpen && (
        <AddToCollectionWrapper
          itemId={itemId}
          itemType={itemType}
          onClose={() => setIsOpen(false)}
        />
      )}
      <Button
        color="primary"
        size="medium"
        variant="text"
        onClick={() => handleOpenClick()}
        startIcon={icon}
      >
        <React.Fragment>
          <span className="hide-on-narrow-mobile">Add to&nbsp;</span>collection
        </React.Fragment>
      </Button>
    </Fragment>
  );
}

AddToCollectionButton.propTypes = {
  itemId: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
};

export default AddToCollectionButton;
